export default __webpack_public_path__ + "static/api-73e3bdae4744ae6b61a1d706bef629f5.svg";